/**
 * @generated SignedSource<<4b8237d9ade119c89ec60d5df73a7b79>>
 * @relayHash 314dcaae70a91a8c2aec9b2c04dbb828
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29c7a3076bb6bd5678012e8694b3490becab3269842600c69ef20ab8ad2ecaea

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_DeferEditionModalQuery } from './src_DeferEditionModalQuery.graphql';

const node: PreloadableConcreteRequest<src_DeferEditionModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "29c7a3076bb6bd5678012e8694b3490becab3269842600c69ef20ab8ad2ecaea",
    "metadata": {},
    "name": "src_DeferEditionModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
